import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Dynamic redux
export var reduxModuleLoaded = createAction("".concat(actionKey, ".REDUX_READY"), function () { return ({}); });
export var initialize = createAction("".concat(actionKey, ".INITIALIZE"), function (_a) {
    var deviationId = _a.deviationId;
    return ({ deviationId: deviationId });
});
export var deinitialize = createAction("".concat(actionKey, ".DEINITIALIZE"), function () { return ({}); });
export var initializeSuccess = createAction("".concat(actionKey, ".INITIALIZE_SUCCESS"), function (payload) { return payload; });
export var initializeTierTags = createAction("".concat(actionKey, ".INITIALIZE_TIER_TAGS"), function (payload) { return payload; });
export var initializeTierTagsSuccess = createAction("".concat(actionKey, ".INITIALIZE_TIER_TAGS_SUCCESS"), function (payload) { return payload; });
export var deleteDeviation = createAction("".concat(actionKey, ".DELETE_DEVIATION"), function (deviation) { return ({ deviation: deviation }); });
export var submitDeviation = createAction("".concat(actionKey, ".SUBMIT_DEVIATION"), function (payload) { return payload; });
export var deviationSaveError = createAction("".concat(actionKey, ".DEVIATION_SAVE_ERROR"), function (message) { return ({
    message: message,
}); });
//# sourceMappingURL=actions.js.map